<mat-card class="card-layout" (click)="cardClick(card, 'self')" [ngClass]="{'disabled-card':card.isDisabled}">
  <mat-card-header>
    <img mat-card-avatar *ngIf="hasAvatarImg" src="{{card.avatarImgSrc}}">
    <mat-card-title *ngIf="card.title">{{card.title}}</mat-card-title>
    <mat-card-subtitle *ngIf="card.subtitle">{{card.subtitle}}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <a class="card-link" [ngClass]="{'has-coming-soon': card.comingSoon === true}">
      <div class="card-name" [ngStyle]="{'background-color':card.color}">
        <h3 class="card-name-title">{{card.cardContent}}</h3>
      </div>
      <div class="card-info">
        <i class="card-icon" [ngStyle]="{'background-color':card.color}">
          <img *ngIf="hasImg" src="{{card.imageSrc}}">
        </i>
      </div>
    </a>
  </mat-card-content>
  <mat-card-actions *ngIf="card.buttons.length>0">
    <button mat-button *ngFor="let button of card.buttons; index as i;" (click)="cardClick(card,button.data)">button.title</button>
  </mat-card-actions>
</mat-card>
